<!-- index-new HY首页 -->

<template>
  <div ref="wrapper" class="index-page-4">
    <!-- 页头 + 轮播图 -->
    <div style="background: linear-gradient(#bc5454, #edf0f5)">
      <van-row justify="space-between" style="margin: 0 16px; padding: 8px 0" type="flex">
        <van-col span="12">
          <van-row type="flex">
            <van-col span="8">
              <van-image v-if="userInfo.avatar" :src="userInfo.avatar" height="48px" round style="margin-top: 4px"
                width="48px" />
              <van-icon v-else color="#fff" name="user-circle-o" size="48" style="margin-top: 4px" />
            </van-col>
            <van-col span="16">
              <van-dropdown-menu active-color="#ffffff">
                <van-dropdown-item :title="$store.getters.city_name">
                  <van-tree-select :active-id.sync="activeId" :items="items" :main-active-index.sync="activeIndex"
                    @click-item="changeCity" />
                </van-dropdown-item>
              </van-dropdown-menu>
              <div style="
                  margin-left: 8px;
                  color: #fff;
                  width: 100%;
                  font-size: 14px;
                ">
                {{ userInfo.nickName }}
              </div>
            </van-col>
          </van-row>
        </van-col>

        <van-col class="nav-top-right" span="12">
          <van-grid :border="false" :column-num="3" style="color: #fff; font-size: 12px; width: 150px">
            <van-grid-item to="/user-cards">
              <template #icon>
                <van-icon color="#fff" name="images/index-new/kq.svg" size="32" />
              </template>
              <template #text>
                <span style="margin-top: 2px">卡券</span>
              </template>
            </van-grid-item>
            <van-grid-item to="/user-center-index">
              <template #icon>
                <van-icon color="#fff" name="images/index-new/grzx.svg" size="32" />
              </template>
              <template #text>
                <span style="margin-top: 2px" class="budo-49">我的</span>
              </template>
            </van-grid-item>
            <van-grid-item @click="getUserService()">
              <template #icon>
                <van-icon color="#fff" name="images/index-new/kf3.svg" size="32" />
              </template>
              <template #text>
                <span style="margin-top: 2px">客服</span>
              </template>
            </van-grid-item>
          </van-grid>
        </van-col>
      </van-row>

      <!-- 轮播图 -->
      <div style="margin: 4px 16px">
        <ads-images code="index_images"></ads-images>
      </div>
    </div>
    <!-- 页头 + 轮播图 结束 -->

    <div v-if="loading" style="width: 100%; text-align: center; margin-top: 42px">
      <van-loading v-show="loading" color="#1989fa" size="24px" type="spinner"></van-loading>
    </div>

    <!-- 板块 一级分类 -->
    <IndexCateListNew :allowCateInfo="allowCateInfo" :mall_modules="mall_modules" />

    <!-- 循环各个模块 -->
    <div v-for="(module, index) of commonCateList" :key="index" style="border-radius: 8px; background-color: #ffffff">
      <van-cell :border="false" class="cate-top-nav" v-if="show_module_nav_cell(module)">
        <template #title>
          <span style="color: #fff; font-size: 18px"> {{ module.extName || module.extNameV3 }}</span>
        </template>
        <template #default>
          <span style="color: #fff; font-size: 12px">
            <a @click="toModuleIndex(module.topCateId, module.targetUrl)">更多/More</a>
          </span>
        </template>
      </van-cell>

      <!-- 这个模块里的商品 -->
      <ComponentIndexHealth class="cate-goods-list"
        v-if="'/web/health-index' == module.targetUrl || 8 == module.cateId" />

      <ComponentIndexMovie class="cate-goods-list" v-if="'/movie/index' == module.targetUrl || 2 == module.cateId" />

      <ComponentIndexTravel class="cate-goods-list"
        v-if="'/web/travel-index' == module.targetUrl || 7 == module.cateId" />

      <div v-else class="cate-goods-list">
        <GoodsListBlock :cate-id="top_cate_id(module)" :tags="GOODS_TAGS.recommend" :visible-pay="false" />
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/util/axios";
import Vue from "vue";
import { Lazyload } from "vant";
import CitySelect from "@/components/common/city-select";
import AdsImages from "@/components/common/ads-images";
import { api_get_user_cate_id_list } from "@/api/goods-api";
import store from "@/store";
import { areaList } from "@vant/area-data";
import { GOODS_TAGS } from "@/api/constant";
import GoodsListBlock from "@/components/common/GoodsListBlock.vue";
import { wx_get_jsapi_ticket } from "@/api/user";
import { get_user_poi_location } from "@/util/wxSdk";
import { $wx_kefu_rc } from "@/util/wxSdk";
import { change_city_by_location } from "@/util/LocationUtil"

import ComponentIndexMovie from "./ComponentIndexMovie.vue";
import ComponentIndexTravel from "./ComponentIndexTravel.vue";
import ComponentIndexHealth from "./ComponentIndexHealth.vue";

Vue.use(Lazyload);

export default {
  name: "index",

  computed: {
    GOODS_TAGS() {
      return GOODS_TAGS;
    },

    userInfo() {
      return this.$store.getters.userInfo;
    },
  },

  components: {
    AdsImages,
    CitySelect,
    GoodsListBlock,
    ComponentIndexMovie,
    ComponentIndexTravel,
    ComponentIndexHealth,
  },

  data() {
    return {
      areaList,
      items: [],
      activeId: 5101,
      activeIndex: 0,
      active: 0,
      allowCateInfo: [],
      commonCateList: [],
      loading: true,

      mall_modules: [],
    };
  },

  mounted() {
    window.onscroll = this.doScroll;
    budo_log.info("#263 created store-index-new");

    wx_get_jsapi_ticket(
      encodeURIComponent(window.location.href)
    ).then((res) => {
      if (res.code === 0) {
        get_user_poi_location(res, res2 => {
          // 之前是在这里才加载城市列表的
          budo_log.info("#178 store-index-new get_user_poi_location", res2, res)

          var lat = sessionStorage.getItem("USER_CURRENT_POI_LAT")
          var lng = sessionStorage.getItem("USER_CURRENT_POI_LNG")

          // 如果定位位置和选择的位置不同 就提醒用户切换
          change_city_by_location(lat, lng);
        });
      }
    });

    // 加载城市列表
    this.loadCityList();

    // 从后台拿所有顶级目录
    request.post("/mall/wx/wx-user-root-cate-list").then((res) => {
      // 所有顶级目录
      this.mall_modules = res?.data?.map((e) => {
        e.topCateId = e.cateId; // ID
        e.indexNavFlag = e.sort || e.cateId; // 排序
        e.iconImgV3 = e.icon; // 图标
        e.extNameV3 = e.name; // 显示名
        // textColor
        return e;
      }); // MallModules

      // 看客户开通了哪些目录
      this.getAllowCateList();
    });
  },

  methods: {
    show_module_nav_cell(module) {
      if (
        module?.targetUrl == "/v4/WDG?type=A" ||
        module?.targetUrl == "/v4/YHCS?type=A" ||
        module?.targetUrl == "/v4/JDJL?type=A" ||
        module?.targetUrl == "/web/hw-h5"
      ) {
        return false;
      }

      budo_log.info("#200 show_module_nav_cell", module);
      return true;
    },

    top_cate_id(module) {
      budo_log.debug("#194 top_cate_id", module.topCateId, module);

      if (module?.targetUrl == "/web/index") {
        return 1;
      }

      if (module?.targetUrl == "/web/birthday") {
        return 3;
      }

      if (module?.targetUrl?.startsWith("/web/common-index?cateId=")) {
        return Number(module.targetUrl.replace("/web/common-index?cateId=", ""));
      }

      return module?.topCateId;
    },

    getUserService() {
      location.href = $wx_kefu_rc();
    },

    toModuleIndex(id, targetUrl) {
      budo_log.info("#291 toModuleIndex", id, targetUrl);

      if (targetUrl) {
        location.href = targetUrl;
        return;
      }

      if (id === 2) {
        location.href = "/movie/index";
        return;
      }

      let mid = id;

      //生日版块特殊处理
      if (id === 3) {
        mid = 4;
      }

      const module = this.mall_modules.find((mall) => mall.topCateId === mid);
      if (module) {
        this.$store.commit("SET_MALL_MODULE", module);
        sessionStorage.setItem("rc.module-info", JSON.stringify(module));

        this.$store.commit("CLEAR_CART");
        this.$EventBus.$emit("routeInfo", JSON.stringify(module || {}));

        budo_log.info("#318 module_name", module);
      }

      this.$router.push(this.getModuleIndexUrl(id));
    },

    getModuleIndexUrl(cateId) {
      switch (cateId) {
        case 3:
          return "/birthday";
        case 1:
          return "/index";
        case 7:
          return "/travel-index";
        case 8:
          return "/health-index";
        default:
          return "/common-index?cateId=" + cateId;
      }
    },

    getAllowCateList() {
      api_get_user_cate_id_list().then((res) => {
        budo_log.info("#370 getAllowCateList api_get_user_cate_id_list", res);

        if (res.code != 0) {
          // 没有可用卡券 B 这里不 alert 让 App 那边引导用户去绑手机绑卡
          // Dialog.alert({ message: res.msg || "用户无卡券" })
          return;
        }

        this.loading = false;
        const allowCateId = res.data;
        const commonCateIdList = allowCateId.slice();
        budo_log.info("#375 getAllowCateList", commonCateIdList);

        const modules = this.mall_modules.slice();

        budo_log.info("#401 getAllowCateList", commonCateIdList);

        this.allowCateInfo = modules
          .filter(
            (f) =>
              allowCateId.findIndex((item) => item === f.topCateId) >= 0 &&
              f.indexNavFlag > 0
          )
          .sort((a, b) => a.indexNavFlag - b.indexNavFlag);

        this.commonCateList = modules.filter((f) =>
          commonCateIdList.findIndex((item) => item === f.topCateId) >= 0 && f.indexNavFlag > 0
        ).sort((a, b) => a.indexNavFlag - b.indexNavFlag);
      });
    },

    loadCityList() {
      // 加载城市列表
      for (const pid in this.areaList.province_list) {
        const node = {
          text: this.areaList.province_list[pid],
          children: [],
        };

        const cityList = [];
        for (const cid in this.areaList.city_list) {
          if (cid.substring(0, 2) === pid.substring(0, 2)) {
            cityList.push({ text: this.areaList.city_list[cid], id: cid });
          }
        }

        node.children = cityList;
        this.items.push(node);
      }

      this.active = this.$store.getters.city_code;
    },

    changeCity(data) {
      budo_log.info("#429 SET_CITY_NAME", data);

      store.commit("SET_CITY_CODE", data.id.substring(0, 4));
      store.commit("SET_CITY_NAME", data.text);
      window.location.reload();
    },

    doScroll() {
      if (this.timerId) clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        // 获取页面滚动距离之后设置给当前路由的元信息
        this.$route.meta.y = window.pageYOffset;
      }, 300);
    },

    forbidBack() {
      window.history.pushState("forward", null, "#");
      window.history.forward(1);
    },
  },
  // 处理ios url兼容
  beforeRouteEnter(to, from, next) {
    if (
      "/web" + to.path !== location.pathname ||
      "/web" + to.path !== "/web" + to.fullPath
    ) {
      location.assign("/web" + to.fullPath.split("?")[0]);
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "index";

.cate-goods-list {
  margin-bottom: 15px;
  border-radius: 10px;
}

.cate-top-nav {
  background-color: #b3627b;
  border-radius: 8px 8px 0 0;
}
</style>
